import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product, Summary } from '../../../../../../shared/models/models';

@Component({
	selector: 'quote-summary-block',
	template: require('./quote-summary-block.html'),
	styles: [require('./quote-summary-block.scss')]
})
export class QuoteSummaryBlockComponent {
	@Input() addedItems: Product[];
	@Input() quoteSummary: Summary;
	@Output() submitDeclineReason: EventEmitter<string> = new EventEmitter();
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quotes/common/quote-summary-block/quote-summary-block.ts